import { FiAward } from "react-icons/fi";
import { HiAcademicCap } from "react-icons/hi";
import SectionHeading from "../../components/SectionHeading";
import SectionArt from "../../components/SectionArt";
import Reveal from "../../components/Reveal";
import TiltCard from "../../components/TiltCard";

const items = [
  {
    degree: "M.Sc in Cyber Security",
    school: "Mawlana Bhasani Science and Technology University",
    score: "CGPA 3.74 / 4.00",
    dot: "from-aurora-cyan to-aurora-indigo",
  },
  {
    degree: "B.Sc in Software Engineering",
    school: "Daffodil International University",
    score: "CGPA 3.89 / 4.00",
    dot: "from-aurora-violet to-aurora-purple",
  },
  {
    degree: "Higher Secondary Certificate",
    school: "Sristy College, Tangail",
    score: "GPA 4.50 / 5.00",
    dot: "from-aurora-pink to-aurora-rose",
  },
];

const Education = () => {
  return (
    <section id="education" className="relative px-6 py-28 md:py-36">
      <div className="container mx-auto max-w-3xl">
        <SectionArt type="education" className="mx-auto mb-4 h-32 w-44" />
        <SectionHeading
          eyebrow="Education"
          title="Academic Journey"
          subtitle="The foundation behind the craft — where curiosity met computer science."
        />

        <div className="relative pl-10 md:pl-14">
          {/* the line */}
          <div className="absolute left-[14px] top-2 h-[calc(100%-2rem)] w-px bg-gradient-to-b from-aurora-cyan via-aurora-violet to-transparent md:left-[22px]" />

          <div className="flex flex-col gap-8">
            {items.map((item, i) => (
              <Reveal key={item.degree} direction="left" delay={i * 0.1}>
                <div className="relative">
                  {/* node */}
                  <span
                    className={`absolute -left-[34px] top-6 flex h-4 w-4 items-center justify-center rounded-full bg-gradient-to-br ${item.dot} shadow-glow md:-left-[42px]`}
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-white" />
                  </span>

                  <TiltCard className="glass rounded-3xl p-6 md:p-7" max={6}>
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex items-center gap-3">
                        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-hairline bg-fill text-xl text-content">
                          <HiAcademicCap />
                        </span>
                        <div>
                          <h3 className="text-lg font-semibold text-content md:text-xl">
                            {item.degree}
                          </h3>
                          <p className="text-sm text-muted">{item.school}</p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-5 flex flex-wrap items-center gap-3">
                      <span className="inline-flex items-center gap-1.5 rounded-full border border-hairline bg-fill px-3 py-1 text-xs font-medium text-content">
                        <FiAward /> {item.score}
                      </span>
                    </div>
                  </TiltCard>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
